
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"6.5","cy":"3.5","r":"2.5","stroke":"#8F7A61","stroke-width":"2"}}),_c('path',{attrs:{"d":"M12 14c0-2.761-2.462-5-5.5-5S1 11.239 1 14","stroke":"#8F7A61","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"13","cy":"13","r":"6","fill":"#EDE6DD"}}),_c('path',{attrs:{"d":"M14.484 15.271c0-.357-.112-.652-.336-.883-.225-.236-.6-.446-1.123-.63a8.983 8.983 0 01-1.223-.525c-.968-.525-1.453-1.303-1.453-2.334 0-.698.21-1.272.63-1.722.42-.45.99-.717 1.71-.802V7h.997v1.388c.724.105 1.283.416 1.678.934.395.513.592 1.182.592 2.006h-1.509c0-.53-.118-.946-.355-1.25-.233-.306-.552-.46-.955-.46-.399 0-.71.11-.935.328-.225.22-.337.532-.337.94 0 .366.11.66.33.884.225.218.603.427 1.136.624.532.198.95.381 1.253.55.304.167.56.36.767.58.208.214.368.462.48.744.113.282.169.612.169.99 0 .712-.216 1.288-.649 1.73-.428.441-1.027.702-1.796.782V19h-.992v-1.224c-.823-.093-1.457-.391-1.902-.896-.44-.505-.661-1.173-.661-2.006h1.516c0 .53.13.94.393 1.23.266.29.64.435 1.122.435.474 0 .834-.115 1.08-.347.249-.23.373-.538.373-.92z","fill":"#8F7A61"}})])
          )
        }
      }
    